import React from "react";
import "./MainLayout.css";

function MainLayout(props) {  

  return (
    <div className="h-full flex flex-col duration-300 transition">
        <div className="flex-1">{props?.children}</div>
    </div>
  );
}

export default MainLayout;